const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/BackToStartBtn.tsx';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';
import { useIntl } from 'react-intl';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import textMap from 'App/components/AppBar/translations';
import { useCSSClasses } from './styles';
import { logout } from 'App/actions/fixme.login';
import { useDispatch } from 'react-redux';

const alignEndStyle = css`
    margin-left: auto !important;
    padding-right: ${theme.spacing(3)} !important;
`;

export const BackToStartBtn = () => {
    const { formatMessage } = useIntl();
    const classes = useCSSClasses();
    const dispatch = useDispatch();

    const btnClicked = () => {
        dispatch((logout as any)());
    };

    return (
        <Button
            variant="text"
            color="primary"
            type="submit"
            onClick={btnClicked}
            className={alignEndStyle}
            classes={{ root: classes.btnRoot }}
        >
            <Typography variant="body2">{formatMessage(textMap.BackToStart)}</Typography>
        </Button>
    );
};
